import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IApiResponseBody } from '../../../common/models/common';
import { RootState } from '../../app.model';
import { booleanLookup } from '../../../common/constants/common';
import { IConfigDataRetentionState } from './dataRetention.model';
import {
  getConfigDataRetentionById,
  searchConfigDataRetention,
  updateConfigDataRetention,
} from './dataRetention.action';
import { IConfigDataRetention } from '../../../services/master/dataRetention/dataRetention.model';

export const initialState: IConfigDataRetentionState = {
  search: {
    loading: false,
    hasErrors: false,
    data: [],
    count: 0,
    lookups: {},
    tableName: '',
  },
  tableColumnSelection: {
    id: null,
    table_name: null,
    columns: {},
  },
  getById: {
    loading: false,
    hasErrors: false,
    data: null,
  },
  save: {
    loading: false,
    hasErrors: false,
    messages: [],
  },
};

export const configDataRetentionSlice = createSlice({
  name: 'configDataRetention',
  initialState,
  reducers: {
    clearConfigDataRetention: () => {
      return initialState;
    },
    clearConfigDataRetentionMessages: (state) => {
      state.save.messages = [];
    },
    clearConfigDataRetentionGetById: (state) => {
      state.getById.data = null;
    },
    setTableColumnSelection: (state, action: PayloadAction<{ [key: string]: boolean }>) => {
      state.tableColumnSelection.columns = action.payload;
    },
  },
  extraReducers: {
    // Search
    [searchConfigDataRetention.pending.type]: (state) => {
      state.search.loading = true;
    },
    [searchConfigDataRetention.fulfilled.type]: (state, action: PayloadAction<any>) => {
      const { records, total_count, table_name, column_selection } = action.payload;
      state.search.data = records;
      state.search.count = total_count;
      state.search.lookups = { booleanLookup };
      state.search.loading = false;
      state.search.hasErrors = false;
      state.search.tableName = table_name;
      if (column_selection) {
        state.tableColumnSelection.id = column_selection.id;
        const tableSelectionObj = JSON.parse(column_selection.columns as any);
        if (tableSelectionObj.columns) {
          state.tableColumnSelection.column_orders = tableSelectionObj.column_orders;
          state.tableColumnSelection.columns = tableSelectionObj.columns;
        } else {
          state.tableColumnSelection.columns = tableSelectionObj;
        }
      }
      state.tableColumnSelection.table_name = table_name;
    },
    [searchConfigDataRetention.rejected.type]: (state) => {
      state.search.loading = false;
      state.search.hasErrors = true;
    },

    // Get by id
    [getConfigDataRetentionById.pending.type]: (state) => {
      state.getById.loading = true;
    },
    [getConfigDataRetentionById.fulfilled.type]: (
      state,
      action: PayloadAction<IConfigDataRetention>
    ) => {
      state.getById.data = action.payload;
      state.getById.loading = false;
      state.getById.hasErrors = false;
    },
    [getConfigDataRetentionById.rejected.type]: (state) => {
      state.getById.loading = false;
      state.getById.hasErrors = true;
    },

    // Update
    [updateConfigDataRetention.pending.type]: (state) => {
      state.save.loading = true;
      state.save.messages = [];
    },
    [updateConfigDataRetention.fulfilled.type]: (
      state,
      action: PayloadAction<IApiResponseBody<unknown>>
    ) => {
      state.save.loading = false;
      state.save.hasErrors = false;
      state.save.messages = action.payload.messages;
    },
    [updateConfigDataRetention.rejected.type]: (state) => {
      state.save.loading = false;
      state.save.hasErrors = true;
    },
  },
});

// A selector
export const configDataRetentionSelector = (state: RootState) => state.configDataRetention;

// Actions
export const {
  clearConfigDataRetention,
  clearConfigDataRetentionMessages,
  clearConfigDataRetentionGetById,
  setTableColumnSelection,
} = configDataRetentionSlice.actions;

// The reducer
export default configDataRetentionSlice.reducer;
